<div class="content">
  <div class="group">
    <h1>功能导航</h1>

    <a routerLink="/user/profile/seats">我的车票</a>
    <a routerLink="/user/profile/affiliate">我的推广</a>
    <!-- <a routerLink="/trending">巴士动态</a> -->
    <!-- <a routerLink="/business">商务合作</a> -->
  </div>
  <div class="group">
    <h1>条款与政策</h1>

    <a routerLink="/privacy">隐私政策</a>
    <a routerLink="/agreement">用户协议</a>
  </div>
  <div class="group">
    <h1>联系我们</h1>

    <!-- <a routerLink="/about">公司简介</a> -->
    <!-- <a>在线客服</a> -->
    <!-- <a routerLink="/business">商务合作</a> -->
    <!-- <a routerLink="/community">互动社区</a> -->
  </div>
</div>

<app-page-footer></app-page-footer>
